import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import Select from 'react-select'
import { TbSquarePlus, TbSquareMinus } from 'react-icons/tb'
import { IconContext } from "react-icons";

function ModifyFormSchedule({
  selectSchedule,
  callback,
}) {
  const [idSchedule, setSelectSchedule] = useState(selectSchedule);
  const [selectclient, setSelectclient] = useState({});
  const [selectService, setSelectService] = useState({});
  const [selectTech, setSelectTech] = useState({});
  const [listTech, setTech] = useState([]);
  const [listClass, setClass] = useState([]);
  const [listOffice, setOffice] = useState([]);
  const [listClients, setClients] = useState([]);
  const [listServices, SetService] = useState([]);
  const [clientExist, showClientForm] = useState(true);
  const [infoForm, setForm] = useState({
    client: '',
    service: '',
    assigned_user: 0,
    schedule_date: '',
    schedule_hour: '',
    schedule_city: '',
    schedule_address: '',
    state: 'C',
    id_client: '',
    name_client: '',
    placa: '',
    vehicleclass: '',
    office: '',
    insurance: '',
    email: '',
    phone: '',
    observation: '',
    type: '',
  });

  useEffect(() => {
    const init = async () => {
      if (idSchedule !== 0) {
        const infoSchedule = await get('/schedule/' + idSchedule);
        if (infoSchedule.success) {
          const {
            id,
            client,
            client_name,
            service,
            service_name,
            assigned_user,
            assigned_user_name,
            schedule_date,
            schedule_hour,
            schedule_city,
            schedule_address,
            state,
            placa,
            vehicleclass,
            office,
            insurance,
            email,
            phone,
            observation,
            type,
          } = infoSchedule.data;

          setSelectclient({ value: client, label: client_name });
          setSelectService({ value: service, label: service_name });
          setSelectTech({ value: assigned_user, label: assigned_user_name });
          showClientForm(true)

          setForm({
            id,
            client,
            service,
            assigned_user,
            schedule_date,
            schedule_hour,
            schedule_city,
            schedule_address,
            state,
            placa,
            id_client: '',
            name_client: '',
            vehicleclass,
            office,
            insurance,
            email,
            phone,
            observation,
            type,
          });
        }
      }
    }
    init();
  }, [idSchedule]);

  useEffect(() => {
    const getClient = async () => {
      const client = selectclient.value;
      if (client) {
        const infoclient = await get('/client/' + client);
        if (infoclient.success) {
          const infoSelectClient = infoclient.data
          setForm(prevInfoForm => ({
            ...prevInfoForm,
            email: infoSelectClient.email,
            phone: infoSelectClient.phone,
            type: infoSelectClient.type,
          })
          )
        }
      }
    }
    getClient()
  }, [selectclient])

  const handleForm = ({ target }) => {

    if (target.name === 'client') setSelectclient(target.data);
    if (target.name === 'service') setSelectService(target.data);
    if (target.name === 'assigned_user') setSelectTech(target.data);

    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (target.name !== 'assigned_user') {
      setForm({ ...infoForm, [target.name]: value });
    } else {
      setForm({ ...infoForm, [target.name]: value, state: 'S' });
    }
  };

  const saveForm = async (e) => {
    e.preventDefault();
    let respo,
      variant = '',
      msg = '';

    const body = { ...infoForm, clientExist };
    if (parseInt(idSchedule) !== 0) {
      respo = await put('/schedule/modify/' + idSchedule, body);
      msg = 'Agenda editada Correctamente';
    } else {
      respo = await post('/schedule/create/', body);
      msg = 'Agenda creada Correctamente';
    }

    if (respo.success) {
      variant = 'success';
      setSelectSchedule(respo.data.id);
    } else {
      variant = 'danger';
      msg = respo.message;
    }

    callback({ type: variant, message: msg });
  };

  useEffect(() => {
    const initForm = async () => {
      const infoSchedule = await get('/schedule/info/');
      if (infoSchedule.success) {
        setClients(infoSchedule.data.clients);
        SetService(infoSchedule.data.services);
        setTech(infoSchedule.data.tech)
        setClass(infoSchedule.data.vehicleClass)
        setOffice(infoSchedule.data.office)
      }
    }
    initForm();
  }, []);

  const formCreateClient = () => {
    return (
      <Fragment>
        <Form.Label htmlFor="id_client">Nit</Form.Label>
        <Form.Control
          name="id_client"
          value={infoForm.id_client}
          onChange={(e) => handleForm(e)}
          type="text"
          required
        />
        <Form.Label htmlFor="nombre">Nombre</Form.Label>
        <Form.Control
          name="name_client"
          value={infoForm.name_client}
          onChange={(e) => handleForm(e)}
          type="text"
          required
        />
      </Fragment>
    )
  }

  return (
    <Fragment>
      <Container className="m-3">
        <Form onSubmit={(e) => saveForm(e)}>
          <Form.Label htmlFor="id_client"> Cliente
            {clientExist
              ? <IconContext.Provider value={{ size: '30', color: 'red' }}> <TbSquarePlus onClick={() => showClientForm(false)} /> </IconContext.Provider>
              : <IconContext.Provider value={{ size: '30', color: 'red' }}> <TbSquareMinus onClick={() => showClientForm(true)} /> </IconContext.Provider>
            }
          </Form.Label>
          <Row>
            <Col>
              {clientExist
                ? <Select options={listClients} value={selectclient} onChange={(data) => handleForm({ target: { value: data.value, name: "client", type: "text", data } })} required />
                : formCreateClient()}
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label htmlFor="ciudad">Tipo Cliente</Form.Label>
              <Form.Select
                name="type"
                value={infoForm.type}
                onChange={(e) => handleForm(e)}
                aria-label="Default select example"
              >
                <option value="">Seleccione</option>
                <option value="PARTICULAR">PARTICULAR</option>
                <option value="CONCESIONARIO">CONCESIONARIO</option>

              </Form.Select>
            </Col>
            <Col>
              <Form.Label htmlFor="email">Correo Electronico</Form.Label>
              <Form.Control
                type="text"
                name="email"
                value={infoForm.email}
                className="fw-bold text-uppercase"
                onChange={(e) => handleForm(e)}
                required
              />
            </Col>
            <Col>
              <Form.Label htmlFor="phone">Telefono</Form.Label>
              <Form.Control
                type="text"
                name="phone"
                value={infoForm.phone}
                className="fw-bold text-uppercase"
                onChange={(e) => handleForm(e)}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label htmlFor="id_client">Servicio</Form.Label>
              <Select options={listServices} value={selectService} onChange={(data) => handleForm({ target: { value: data.value, name: "service", type: "text", data } })} required />
            </Col>
            <Col><Form.Label htmlFor="id_client">Tecnico</Form.Label>
              <Select options={listTech} value={selectTech} onChange={(data) => handleForm({ target: { value: data.value, name: "assigned_user", type: "text", data } })} required />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label htmlFor="nombre">Fecha</Form.Label>
              <Form.Control
                name="schedule_date"
                value={infoForm.schedule_date}
                onChange={(e) => handleForm(e)}
                type="date"
                required
              />
            </Col>
            <Col><Form.Label htmlFor="nombre">Hora</Form.Label>
              <Form.Control
                name="schedule_hour"
                value={infoForm.schedule_hour}
                onChange={(e) => handleForm(e)}
                type="time"
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label htmlFor="office">Oficina</Form.Label>
              <Form.Select
                name="office"
                value={infoForm.office}
                onChange={(e) => handleForm(e)}
                aria-label="Default select example"
                required
              >
                <option value="">Seleccione</option>
                {listOffice.map((element, i) => {
                  return (
                    <option key={i} value={element.value}>
                      {element.label}
                    </option>
                  );
                })}
              </Form.Select>
            </Col>
            <Col>
              <Form.Label htmlFor="email">Ciudad</Form.Label>
              <Form.Control
                name="schedule_city"
                value={infoForm.schedule_city}
                onChange={(e) => handleForm(e)}
                type="text"
                required
              />
            </Col>
            <Col>
              <Form.Label htmlFor="email">Direccion</Form.Label>
              <Form.Control
                name="schedule_address"
                value={infoForm.schedule_address}
                onChange={(e) => handleForm(e)}
                type="text"
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label htmlFor="placa">Placa</Form.Label>
              <Form.Control
                type="text"
                name="placa"
                maxLength={6}
                value={infoForm.placa}
                className="fw-bold text-uppercase"
                onChange={(e) => handleForm(e)}
                required
              />
            </Col>
            <Col>
              <Form.Label htmlFor="office">Clase</Form.Label>
              <Form.Select
                name="vehicleclass"
                value={infoForm.vehicleclass}
                onChange={(e) => handleForm(e)}
                aria-label="Default select example"
                required
              >
                <option value="">Seleccione</option>
                {listClass.map((element, i) => {
                  return (
                    <option key={i} value={element.value}>
                      {element.label}
                    </option>
                  );
                })}
              </Form.Select>
            </Col>
            <Col>
              <Form.Label htmlFor="insurance">Aseguradora</Form.Label>
              <Form.Control
                type="text"
                name="insurance"
                value={infoForm.insurance}
                className="fw-bold text-uppercase"
                onChange={(e) => handleForm(e)}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label htmlFor="observation">Observaciones Adicionales</Form.Label>
              <Form.Control
                type="textarea"
                name="observation"
                value={infoForm.observation}
                className="fw-bold text-uppercase"
                onChange={(e) => handleForm(e)}
                maxLength={600}
              />
            </Col>
          </Row>

          <Form.Label htmlFor="email">Estado</Form.Label>
          <Form.Select
            name="state"
            value={infoForm.state}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value='C'> Creado </option>
            <option value='S'> Asignada </option>
            <option value='P'> Proceso </option>
            <option value='T'> Terminado </option>
            <option value='CA'> Cancelado </option>
          </Form.Select>




          <Row className="text-center m-3">
            <Col>
              <Button variant="secondary">Limpiar Formulario</Button>
            </Col>
            <Col>
              <Button
                type="submit"
                variant="primary"
              >
                Guardar Informacion
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </Fragment>
  );
}

export default ModifyFormSchedule;
